import { ComponentProps } from 'react';

export function MagnifyingGlass({ ...props }: ComponentProps<'svg'>) {
  return (
    <svg
      {...props}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.5063 29.4375L23.1313 21.0625C24.9438 18.8438 25.9438 16.05 25.9438 13C25.9438 5.81875 20.1231 0 12.9438 0C5.76439 0 0 5.82062 0 13C0 20.1794 5.82001 26 12.9438 26C15.9931 26 18.7906 24.9431 21.0063 23.185L29.3813 31.56C29.7313 31.8562 30.1188 32 30.5 32C30.8813 32 31.2675 31.8535 31.5606 31.5606C32.1438 30.975 32.1438 30.025 31.5063 29.4375ZM3.00001 13C3.00001 7.48625 7.48626 3 13 3C18.5138 3 23 7.48625 23 13C23 18.5138 18.5138 23 13 23C7.48626 23 3.00001 18.5125 3.00001 13Z"
        fill="currentColor"
      />
    </svg>
  );
}
